import { TMkStep } from '@typescript'
import { EMkRCIDepositsAction, IMkAccountState, TMkRCIDepositsAction } from '../types'

export const rciDepositsReducer = (state: IMkAccountState, action: TMkRCIDepositsAction): IMkAccountState => {
  switch (action.type) {
    case EMkRCIDepositsAction.SET_DRAFT:
      return {
        ...state,
        rciDepositsDraft: action.payload,
      }
    case EMkRCIDepositsAction.UPDATE_FIELD: {
      if (!state.rciDepositsDraft) return state

      const { stepName, fieldName, fieldValue, fieldType } = action.payload

      let valueToUse = fieldValue

      if (fieldType === 'checkbox' && !valueToUse) {
        valueToUse = ''
      }

      const updatedSteps = state.rciDepositsDraft.steps.map((step: TMkStep) => ({
        ...step,
        ...(step.name === stepName && {
          formState: {
            ...step.formState,
            [fieldName]: valueToUse as string,
          },
        }),
      }))

      return {
        ...state,
        rciDepositsDraft: {
          ...state.rciDepositsDraft,
          steps: updatedSteps,
        },
      }
    }
    case EMkRCIDepositsAction.SET_ERROR:
      return {
        ...state,
        rciDepositsErrors: [...(state.rciDepositsErrors || []), action.payload],
      }
    case EMkRCIDepositsAction.CLEAR_ERROR:
      return {
        ...state,
        rciDepositsErrors: [],
      }
    case EMkRCIDepositsAction.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    default:
      return state
  }
}
